import { IBase } from './base.interface';

export enum PaymentProvider {
  PAYLINE = 'PAYLINE',
  PAYGREEN = 'PAYGREEN',
  WORLDLINE = 'WORLDLINE',
}

export interface IBasePaymentProvider extends IBase {
  type: PaymentProvider;

  paymentMethodsIds: string[];
}

export interface IPaylinePaymentProvider extends IBasePaymentProvider {
  type: PaymentProvider.PAYLINE;

  shops: {
    _id: string;
  }[];

  vadRetailer: string;

  vadAccessKey: string;

  vadContract: string;
}

export interface IPaygreenPaymentProvider extends IBasePaymentProvider {
  type: PaymentProvider.PAYGREEN;

  rootShopId: string;

  marketplace: boolean;

  shops: {
    _id: string;
    shopId: string;
    fees: number;
  }[];

  publicKey: string;

  secretKey: string;
}

export interface IWorldlinePaymentProvider extends IBasePaymentProvider {
  type: PaymentProvider.WORLDLINE;

  merchantId: string;

  apiKey: string;

  apiSecret: string;

  shops: {
    _id: string;
    fees: number;
  }[];
}

export type IPaymentProvider = IPaygreenPaymentProvider | IWorldlinePaymentProvider;
